import styled from 'styled-components';
import { colors } from '../../constants';
import { useTranslation } from 'react-i18next';

const Row = styled.ul``;
const Item = styled.li``;
const Copyright = styled.p``;

interface IProps {
    className?: string;
}

const BaseFooter = ({ className }: IProps) => {
    const {
        t,
        i18n: { language },
    } = useTranslation();

    const privacyurl =
        language === 'fr'
            ? 'https://www.pearle.be/fr_BE/accueil/privacy-policy'
            : 'https://www.pearle.be/nl_BE/home/disclaimer-privacy';
    const termsUrl =
        language === 'fr'
            ? 'https://www.pearle.be/fr_BE/accueil/conditions-generales'
            : 'https://www.pearle.be/nl_BE/home/algemene-voorwaarden';

    return (
        <footer className={className}>
            <Row>
                <Item>
                    <a href={privacyurl}>{t('privacy')}</a>
                </Item>
                <Item>
                    <a href={termsUrl}>{t('terms')}</a>
                </Item>
            </Row>
            <Copyright>© Copyright Pearle.be</Copyright>
        </footer>
    );
};

export const Footer = styled(BaseFooter)`
    padding: 0 1rem 3.5rem;
    margin-top: 2.5rem;
    border-top: 1px solid ${colors.greyLight};

    ${Row} {
        display: flex;
        flex-flow: row wrap;
        margin: 0 auto;
        justify-content: center;
        max-width: 80%;
    }

    ${Item} {
        display: block;
        flex: 0 0 auto;
        margin: 1.5rem 0.5rem 0;
        color: ${colors.offBlack};
    }

    a {
        font-weight: 500;

        &:hover {
            text-decoration: underline;
        }
    }

    ${Copyright} {
        text-align: center;
        margin-top: 1.5rem;
    }
`;
